// extracted by mini-css-extract-plugin
export default {"action-parameters":"yXLHppnNgh3PuUP6svL0"};